/**
 * 各ページの構造化データ（JSON-LD）
 * ルートの meta.jsonld から参照し、router.beforeEach で <head> に挿入します。
 * 出典: 【20260621】株式会社U-CREATE_構造化データ_コピペ用
 */

// トップページ（Organization + WebSite）
export const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://u-create21.com/#organization',
      name: '株式会社U-CREATE',
      url: 'https://u-create21.com/',
      description:
        '株式会社U-CREATEは、経営者様の「これをやりたい」というご要望に応え、Webマーケティングを通じてWebサイト・LP・ECサイト/モールの制作やシステム開発などを行い、目的達成・課題解決を支援するIT企業です。集客・求人・業務効率化に強みを持ち、「マーケティング」「コード・プログラム」「デザイン」の3分野の高いスキルで、Web・ITのパートナーとして事業をサポートします。',
      address: {
        '@type': 'PostalAddress',
        postalCode: '500-8468',
        addressCountry: 'JP',
        addressRegion: '岐阜県',
        addressLocality: '岐阜市',
        streetAddress: '加納桜田町2-5-2',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: '事業・サービス一覧',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Webマーケティング（SNS・SEO・MEO支援、広告運用代行、市場・競合の調査分析）',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Web制作・システム開発（ホームページ制作、システム開発、ECサイト/ECモール制作）',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: '求人支援（求人コンサルティング、自社求人サイト制作、求人媒体の展開）',
              url: 'https://u-create21.com/recruit-service/',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'DTP・デザイン（名刺・封筒・チラシ等のデザイン制作、紙媒体印刷、動画編集）',
            },
          },
        ],
      },
    },
    {
      '@type': 'WebSite',
      '@id': 'https://u-create21.com/#website',
      url: 'https://u-create21.com/',
      name: 'U-CREATE',
      description:
        'ウェブマーケティング×ホームページ制作なら岐阜市の株式会社U-CREATE。市場分析・競合調査を行い、集客・販売強化・求人強化を目指すホームページ制作を得意とし、制作後のSEO対策・広告運用・SNS運用・名刺/パンフレット作成まで支援します。',
      inLanguage: 'ja',
      publisher: {
        '@id': 'https://u-create21.com/#organization',
      },
    },
  ],
};

// 求人支援サービス（Organization + Service）
export const recruitServiceJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://u-create21.com/#organization',
      name: '株式会社U-CREATE',
      url: 'https://u-create21.com/',
      description:
        '株式会社U-CREATEは、経営者様の「これをやりたい」というご要望に応え、Webマーケティングを通じてWebサイト・LP・ECサイト/モールの制作やシステム開発などを行い、目的達成・課題解決を支援するIT企業です。集客・求人・業務効率化に強みを持ち、「マーケティング」「コード・プログラム」「デザイン」の3分野の高いスキルで、Web・ITのパートナーとして事業をサポートします。',
      address: {
        '@type': 'PostalAddress',
        postalCode: '500-8468',
        addressCountry: 'JP',
        addressRegion: '岐阜県',
        addressLocality: '岐阜市',
        streetAddress: '加納桜田町2-5-2',
      },
    },
    {
      '@type': 'Service',
      '@id': 'https://u-create21.com/recruit-service/#service',
      name: '求人支援サービス（応募が増える求人強化）',
      description:
        '求人・採用にお困りの経営者向けの求人支援サービス。SNS不要・リスト不要・知名度不要で、これまでの支援実績で応募数・採用数の増加の成功率100%。求人コンサルティング、自社求人サイト制作、求人媒体の展開とコンテンツ制作を行い、有料求人媒体に頼らず安定的な応募獲得を支援します。初回無料相談を実施。',
      serviceType: '求人支援・採用マーケティング',
      provider: {
        '@id': 'https://u-create21.com/#organization',
      },
      areaServed: '日本',
      url: 'https://u-create21.com/recruit-service/',
    },
  ],
};
